import React from 'react';
import LetterBlock from 'components/UI/LetterBlock/LetterBlock';
import './SoundTypes.module.scss';
import MultiKeyboardBlocks from '../MultiKeyboardBlocks/MultiKeyboardBlocks';

export default function TwoSymbolSounds() {
    return (
        <div styleName="grid-wrapper ">
            <div styleName="row">
                <MultiKeyboardBlocks letters="ei">
                    <LetterBlock letter="e" soundType="two-symbol-sound" />
                    <LetterBlock letter="i" soundType="two-symbol-sound" />
                </MultiKeyboardBlocks>
                <MultiKeyboardBlocks letters="ij">
                    <LetterBlock letter="i" soundType="two-symbol-sound" />
                    <LetterBlock letter="j" soundType="two-symbol-sound" />
                </MultiKeyboardBlocks>
                <MultiKeyboardBlocks letters="ui">
                    <LetterBlock letter="u" soundType="two-symbol-sound" />
                    <LetterBlock letter="i" soundType="two-symbol-sound" />
                </MultiKeyboardBlocks>
                <MultiKeyboardBlocks letters="eu">
                    <LetterBlock letter="e" soundType="two-symbol-sound" />
                    <LetterBlock letter="u" soundType="two-symbol-sound" />
                </MultiKeyboardBlocks>
            </div>
            <div styleName="row">
                <MultiKeyboardBlocks letters="oe">
                    <LetterBlock letter="o" soundType="two-symbol-sound" />
                    <LetterBlock letter="e" soundType="two-symbol-sound" />
                </MultiKeyboardBlocks>
                <MultiKeyboardBlocks letters="ie">
                    <LetterBlock letter="i" soundType="two-symbol-sound" />
                    <LetterBlock letter="e" soundType="two-symbol-sound" />
                </MultiKeyboardBlocks>
                <MultiKeyboardBlocks letters="au">
                    <LetterBlock letter="a" soundType="two-symbol-sound" />
                    <LetterBlock letter="u" soundType="two-symbol-sound" />
                </MultiKeyboardBlocks>
                <MultiKeyboardBlocks letters="ou">
                    <LetterBlock letter="o" soundType="two-symbol-sound" />
                    <LetterBlock letter="u" soundType="two-symbol-sound" />
                </MultiKeyboardBlocks>
            </div>
        </div>
    );
}
